// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/styles.scss
// module id = 1243
// module chunks = 0